module.exports = __webpack_public_path__ + "static/media/cc-apple-pay.d19e20a5.svg";